// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ViewAdjustment_wrapper__20Ty1","wrapper_button":"ViewAdjustment_wrapper_button__1RV9j"};